import React, { useState } from 'react';
import moment from 'moment';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { VscArrowSmallLeft, VscArrowSmallRight } from "react-icons/vsc";
import { useEffect } from 'react';

const CalendarComp = ({setDateActive}) => {
    const lang = sessionStorage.getItem('lang') || 'en';
    const currentDate = new Date();    
    let sliderRef = useRef(null);
    const [currentDateIndex, setCurrentDateIndex] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSlides, setTotalSlides] = useState(0);
    const [totalShowSlides, setTotalShowSlides] = useState(0)
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    const handleClick = (index, date) => {
        setCurrentDateIndex(index)
        setDateActive(date)
    }
    useEffect(() => {
        if (sliderRef) {
            setTotalSlides(sliderRef.props.children.length);
        }
    }, [sliderRef, totalSlides, currentIndex]);

  
    const renderHeader = () => {
        const dateFormatM = 'MMMM';
        const dateFormatY = 'YYYY'
        return (
            <div className="header">
                <div className="date">
                    {moment(currentDate).format(dateFormatM)}
                    <br />
                    {moment(currentDate).format(dateFormatY)}

                </div>
            </div>
        );
    };

    const getLast7Days = () => {
        const currentDate = new Date();
        const last7Days = [];

        // Loop to get the last 7 days
        for (let i = 6; i >= 0; i--) {
            const date = new Date(currentDate);
            date.setDate(currentDate.getDate() - i); // Subtract i days from current date
            last7Days.push(date);
        }
        return last7Days;
    };

    const renderDays = () => {
        const days = [];
        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 7,
            slidesToScroll: 7,
            arrows: false,
            centerPadding: "20px",
            afterChange: (index) => {
                setCurrentIndex(index);
                setTotalShowSlides(7);
            },
            responsive: [
                {
                    breakpoint: 1299,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(6)
                        },
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(5)
                        },
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(6)
                        },
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(5)
                        },
                    }
                },
                {
                    breakpoint: 668,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(4)
                        },
                    }
                },
                {
                    breakpoint: 568,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(3)
                        },
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(2)
                        },
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1.5,
                        afterChange: (index) => {

                            setCurrentIndex(index);
                            setTotalShowSlides(1.5)
                        },
                    }
                }
            ]

        };
     
        const last7Days = getLast7Days(); // Assuming getLast7Days() is defined
        last7Days.forEach((date, index) => {            
            const dayOfWeekIndex = date.getDay();
            const dayOfWeekString = daysOfWeek[dayOfWeekIndex];
            const dayNumber = date.getDate();            
            days.push(
                <div onClick={()=> handleClick(index, date.toISOString().split('T')[0])} key={`last7-${date.toISOString().split('T')[0]}`} className={`container-day cursor-pointer ${currentDateIndex === index && 'active'}`}>
                    <div className={`day-content day-number`}>
                        {dayNumber > 9 ? dayNumber : `0${dayNumber}`}
                    </div>
                    <div className='day-content day'>
                        {dayOfWeekString}
                    </div>
                </div>
            );
        });

        return <div className="days"><Slider ref={slider => {
            sliderRef = slider;
        }}
            {...settings}>{days}</Slider></div>;
    };



    return (
        <div className="calendar">
            <Row className='align-items-center'>
                <Col xs={7} sm={8} md={9}>{renderDays()}</Col>
                <Col xs={5} sm={4} md={3}>
                    <div className='text-center'>
                        {renderHeader()}
                        <div>
                            <Button aria-label="Aria label" className="btn-transparent px-0 px-md-2" onClick={previous} disabled={currentIndex === 0}>
                                {lang === 'en' ? <VscArrowSmallLeft size={25} /> : <VscArrowSmallRight size={25} />}
                            </Button>
                            <span>Swipe</span>
                            <Button aria-label="Aria label" className="btn-transparent  px-0 px-md-2" onClick={next} disabled={currentIndex === totalSlides - totalShowSlides}>
                                {lang === 'en' ? <VscArrowSmallRight size={25} /> : <VscArrowSmallLeft size={25} />}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>


        </div>
    );
};

export default CalendarComp;